export class WindowTags {
  public static readonly WindowUnknown = "Window Unknown";
  public static readonly WindowSliding = "Window Sliding";
  public static readonly WindowAwning = "Window Awning";
  public static readonly WindowFixed = "Window Fixed";
  public static readonly WindowCasement = "Window Casement";
  public static readonly WindowDoubleHung = "Window Double Hung";
};
